import React from "react";
import TeamCard from "./TeamCard";


function WebTeam(props)
{
  const[view,setView]=React.useState("no");

  function handleClickMore()
  {
    setView("yes");
  }
  function handleClickLess()
  {
    setView("no");
  }
    return(
        <div className="team-section" id="web-dev">
            <h3 className="team-heading">Web Development Team</h3>
            {props.info.filter((val)=>{
                  return (val[2]==="Web" && val[4]==="Lead");
              }).map((item,index)=>{
                  return <TeamCard key={index} name={item[1]} position={item[4]} github={item[5]} linkedIn={item[7]} twitter={item[8]} image={item[3]}/>
              })}
              {view==="yes" && props.info.filter((val)=>{
                  return (val[2]==="Web" && val[4]==="Member");
              }).map((item,index)=>{
                  return <TeamCard key={index} name={item[1]} position={item[4]} github={item[5]} linkedIn={item[7]} twitter={item[8]} image={item[3]}/>
              })}
              <div className="button">
                {view==="no" && <button id="view-web" className="team-button" onClick={handleClickMore}>VIEW ALL</button>}
                {view==="yes" && <button id="view-web" className="team-button" onClick={handleClickLess}>VIEW LESS</button>}
              </div>
            </div>
    );
}

export default WebTeam;